module.exports = __webpack_public_path__ + "img/desktop/Menus-betmenu/btn-history-up@3x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/desktop/Menus-betmenu/btn-history-up@3x.png
// module id = 559
// module chunks = 0